import React from 'react';
import PropTypes from 'prop-types'


/**
 * {selectedActivity.id} {levelId} {indicator.id}
 * @param {*} param0 
 */
const Indicators = ({ selectedAssessment, selectedActivity, items, levelId, 
     updateAnswer, isIndicatorChecked, errorMessage }) => { //, store: { firestore }

    return <div>
        {items ? items.map( (indicator,i) => 
            <div key={i} className="ms-Grid-col ms-lg3" >
                <input type="radio" name={levelId} value={indicator.id} id={selectedActivity.id + indicator.id + i}  
                    defaultChecked={isIndicatorChecked(selectedAssessment.answers,selectedActivity.id,levelId,indicator.id)}
                    onClick={updateAnswer}                    
                />
                <label htmlFor={indicator.id}>{indicator.text}</label>
            </div> )
            :  <span>Loading</span>}
        </div>
    
}

Indicators.propTypes = {
    items: PropTypes.array,
    levelId: PropTypes.string
  }

  export default Indicators


// WEBPACK FOOTER //
// ./src/indicators/components/Indicators.js